import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Success Icon
import {
    Box,
    Typography
} from '@mui/material';
import React, { useContext } from 'react';
import { ApiContext } from './ApiProvider';

const SuccessStep = () => {
    const { booking, preCheckSettings } = useContext(ApiContext);

    const leadBooker = booking?.party?.find((p, index) => index === 0);
    const confirmationEmail = leadBooker?.email || 'your registered email';

    const successMessage = `Confirmation email has been sent to ${confirmationEmail}.\nNo further action is required at this time.\n\nEnjoy your tour!`;

    return (
        <Box sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <CheckCircleIcon sx={{
                fontSize: 32,
                color: 'success.light',
                mb: 2,
            }} />
            <Typography variant="h5" sx={{
                fontWeight: 'bold',
                fontSize: { xs: '1.25rem', sm: '1.5rem' },
                lineHeight: 1.2,
                mx: -4,
                mb: 3
            }} gutterBottom>
                You have successfully completed your pre-check-in!
            </Typography>
            {preCheckSettings?.confirmation_message && (
                <Typography variant="body1" color="text.primary" component="div" sx={{ mb: 2 }}>
                    {preCheckSettings.confirmation_message.split('\n').map((line, index) => (
                        <span key={index}>{line}<br /></span>
                    ))}
                </Typography>
            )}
            {!preCheckSettings?.confirmation_message && (<Typography variant="body1" color="text.primary" component="div">
                {successMessage.split('\n').map((line, index) => (
                    <span key={index}>{line}<br /></span>
                ))}
            </Typography>
            )}
        </Box>
    );
};

export default SuccessStep; 